import * as React from "react";
import styles from "./ToolIcon.module.scss";
import { IconSize } from "../../models/iconSize";
import { Tooltip } from "@mui/material";
import classNames from "classnames";
import useImage from "../../hooks/useImage";

interface CustomToolIconProps {
  name: string;
  size: IconSize;
  tooltipTitle?: React.ReactNode;
}

const CutomToolIcon = ({
  name,
  size,
  tooltipTitle,
}: CustomToolIconProps): JSX.Element => {
  const { image } = useImage(name);

  return (
    <div
      className={classNames(styles.iconWrapper, {
        [styles.iconWrapper__large]: size === IconSize.Large,
        [styles.iconWrapper__small]: size === IconSize.Small,
      })}
    >
      <Tooltip title={tooltipTitle ? tooltipTitle : ""} arrow placement="top">
        <img src={image} alt="tool" data-testid={`icon-${name}`} />
      </Tooltip>
    </div>
  );
};

export default CutomToolIcon;
